import {Address} from '../functions/addresses/addresses.types.js'
import {OrderAddress} from '../functions/orders/orders.types.js'
import splitAddress from './splitAddress.js'

// Shopify separates address parts with an invisible word joiner (U+2060), replace it by a space
function removeWordJoiners(value: string) {
    return value.includes('\u2060') ? value.replace(/\u2060/g, ' ').replace(/  +/g, ' ').trim() : value
}

export default (address: Address | OrderAddress): Address | OrderAddress => {
    address.street = removeWordJoiners(address.street || '').trim()
    address.nr = removeWordJoiners(address.nr || '').trim()
    address.addition = removeWordJoiners(address.addition || '').trim()
    if (address.street2) {
        address.street2 = removeWordJoiners(address.street2)
    }
    address.postalCode = (address.postalCode || '').trim()
    address.city = (address.city || '').trim()
    address.country = (address.country || '').trim()

    if (!address.nr) {
        const splittedAddress = splitAddress(address.street)

        address.street = splittedAddress.street
        address.nr = splittedAddress.nr
        address.addition = splittedAddress.addition

        if (!address.nr && /^[0-9]{1,4}[^0-9]{0,4}$/.test(address.street2)) {
            address.nr = address.street2
            address.street2 = ''
        }
    }

    address.street = address.street.trim()
    address.nr = address.nr.toUpperCase()

    if (!address.addition) {
        const nrAddition = address.nr.match(/[0-9]+|[^0-9]/gi)

        if (nrAddition?.length ?? 0 > 1) {
            address.nr = nrAddition?.shift() || ''
            address.addition = nrAddition?.join('') || ''
        }
    }

    address.nr = address.nr.trim()
    address.addition = address.addition.replace(/-/g, '').toUpperCase().trim()

    if (/[0-9]/.test(address.addition[0])) {
        address.addition = `-${address.addition}`
    }

    address.country = address.country.toUpperCase().trim()
    address.postalCode = address.postalCode.toUpperCase().replace(/  +/g, ' ').trim()

    if (address.country === 'NL' && /^[0-9]{4}[A-Z]{2}$/.test(address.postalCode)) {
        address.postalCode = `${address.postalCode.substr(0, 4)} ${address.postalCode.substr(4, 2)}`
    }

    if (address.country === 'DE' && /^D-[0-9]{5}$/.test(address.postalCode)) {
        address.postalCode = address.postalCode.substring(2, 7)
    }

    address.city = address.city.trim()

    return address
}
